import { isServiceOrder, type OrderSummary } from '#domain/Order.ts';
import { filterStopInSearch } from '#utils/searchUtils.ts';

export const containsOrderSearchTerm = (item: OrderSummary, search: string) => {
    const text = search.trim().toLowerCase();
    return (
        item.number?.toLowerCase().includes(text) ||
        item.customerName?.toLowerCase().includes(text) ||
        item.tourName?.toLowerCase().includes(text) ||
        item.truck?.name?.toLowerCase().includes(text) ||
        (isServiceOrder(item)
            ? item.description.toLowerCase().includes(text) || filterStopInSearch(text, item.executionStop)
            : filterStopInSearch(text, item.loadingStop) || filterStopInSearch(text, item.unloadingStop))
    );
};
